// client/src/pages/Game/Battlefield/index.js

import Battlefield from './Battlefield';
export default Battlefield;